<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      PCB(II) Statement
    </h4>

    <v-row
      v-if="companyEmployee.pcb_statements.length <1"
      class="mx-0"
    >
      <span class="mx-2"> No data available</span>
    </v-row>

    <v-row
      v-else
      class="mx-0"
      no-gutters
    >
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="2"
      >
        Month
      </v-col>
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="3"
      >
        <v-row no-gutters>
          <v-col class="border-bottom-black">
            Amount (RM)
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="border-right-black">
            PCB
          </v-col>
          <v-col>CP38</v-col>
        </v-row>
      </v-col>
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="3"
      >
        <v-row no-gutters>
          <v-col class="border-bottom-black">
            Receipt/Bank Slip/Transaction No.
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="border-right-black">
            PCB
          </v-col>
          <v-col>CP38</v-col>
        </v-row>
      </v-col>
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="3"
      >
        <v-row no-gutters>
          <v-col class="border-bottom-black">
            Transaction Date
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="border-right-black">
            PCB
          </v-col>
          <v-col>CP38</v-col>
        </v-row>
      </v-col>
      <v-col
        cols="1"
        class="border-bottom-black"
      />

      <v-col cols="12">
        <v-row
          v-for="pcbStatement in companyEmployee.pcb_statements"
          :key="pcbStatement.id"
          no-gutters
          class="border-bottom-black"
        >
          <v-col
            cols="2"
            class="text-center border-right-black"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ pcbStatement.created_by }}</b> on <b>{{ $moment(pcbStatement.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ pcbStatement.updated_by }}</b> on <b>{{ $moment(pcbStatement.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>

            {{ $moment(pcbStatement.payroll_period).format('MMM') }}
          </v-col>

          <v-col cols="3">
            <v-row
              class="text-right"
              no-gutters
            >
              <v-col class="border-right-black">
                <span class="pr-1">{{ twoDigit(pcbStatement.pcb_amount) }}</span>
              </v-col>
              <v-col class="border-right-black">
                <span class="pr-1">{{ twoDigit(pcbStatement.cp38_amount) }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="3">
            <v-row
              class="text-center"
              no-gutters
            >
              <v-col class="border-right-black">
                {{ pcbStatement.pcb_receipt_no? pcbStatement.pcb_receipt_no:'N/A' }}
              </v-col>
              <v-col class="border-right-black">
                {{ pcbStatement.cp38_receipt_no? pcbStatement.cp38_receipt_no:'N/A' }}
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="3">
            <v-row
              class="text-center "
              no-gutters
            >
              <v-col class="border-right-black">
                {{ pcbStatement.pcb_transaction_date? pcbStatement.pcb_transaction_date:'N/A' }}
              </v-col>
              <v-col class="border-right-black ">
                {{ pcbStatement.cp38_transaction_date? pcbStatement.cp38_transaction_date:'N/A' }}
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="1"
            class="text-center"
          >
            <employee-profile-payroll-payroll-company-pcb-statement-dialog-edit
              v-if="!companyEmployee.end_date"
              :pcb-statement="pcbStatement"
              @updated="$emit('load')"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyPcbStatementDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/pcb-statement/DialogEdit'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    methods: {
      twoDigit (amount) {
        return (Math.round((amount / 100) * 100) / 100).toFixed(2)
      }, 
    },
  }
</script>

<style scoped>
.border{
  border-left:1px solid red;
}
.border-bottom-black{
  border-bottom:1px solid black
}
.border-right-black{
  border-right:1px solid black
}
</style>
